//INTERNAL
export const UPDATE_LATENCY = 1000;
export const DEBOUNCE_LATENCY = 500;
export const PROVIDER_OWNER = 'buri@mynfo.com';
export const DEFAULT_PAGE_SIZE = 100;

//EXTERNAL
export const RELEASE_TAG = process.env.REACT_APP_RELEASE_TAG || 'build-xyz';
export const ACTIVE_PROFILE = process.env.REACT_APP_ACTIVE_PROFILE || 'local';
export const STRIPE_PUBLIC_KEY = (process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_test_cmlSQ7Dmno5Llj4ydcf3roWK').trim();
export const GOOGLE_ANALYTICS_ID = (process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'UA-110235852-2');
export const HASH_URLS = process.env.REACT_APP_HASH_URLS === "1";

const PROTOCOL = process.env.REACT_APP_TLS === "1" ? 'https' : 'http';
export const API_URL = `${PROTOCOL}://${process.env.REACT_APP_API_HOST||'test-api.adjoy.com'}:${process.env.REACT_APP_API_PORT || 443}`;
export const AUTH_URL = `${PROTOCOL}://${process.env.REACT_APP_AUTH_HOST||'test-auth.adjoy.com'}:${process.env.REACT_APP_AUTH_PORT || 443}`;
export const APPLICATION_ID = process.env.REACT_APP_APPLICATION_ID || 'mynfo_consumer';
export const APPLICATION_SECRET = process.env.REACT_APP_APPLICATION_SECRET || '77a512a1-2315-43dd-9491-6ce8869cae9d';
export const IMAGE_UPLOADER_URL = process.env.REACT_APP_IMAGE_UPLOADER_URL || 'https://us-central1-adjoy-main.cloudfunctions.net/cropAndUploadImageInMemory';
export const VIDEO_UPLOADER_URL = process.env.REACT_APP_VIDEO_UPLOADER_URL || 'https://us-central1-adjoy-main.cloudfunctions.net/processAndUploadVideoInMemory';

export const ADJOY_DEFAULT_CHOOSE_COST = 0.02;
export const ADJOY_DEFAULT_THIS_OR_THAT_COST = 0.02;
export const ADJOY_DEFAULT_RATABLE_COST = 0.04;
export const ADJOY_DEFAULT_QA_COST = 0.02;
export const ADJOY_DEFAULT_REVENUE_SPLIT = 0.5;

//SALES DEMO
export const SALES_ACCOUNT_ID = '1d032692-2e36-492d-96c9-d0117dccde72';//ACTIVE_PROFILE === 'demo' ? '1d032692-2e36-492d-96c9-d0117dccde72' : 'c0ddf244-5f5c-4142-a7b8-eb6e55bd2425';

export const DABBL_PUBLISHER_ID = process.env.REACT_APP_DABBL_PUBLISHER_ID || 'e283ac77-2b89-46ad-8b94-12a33e5b3c94';

//EVENTUALLY REFACTOR TO THIS...
//REACT_APP_API_URL=''
//REACT_APP_AUTH_URL=''
//REACT_APP_RELEASE_TAG=''
//REACT_APP_ACTIVE_PROFILE=''
//REACT_APP_APPLICATION_ID=''
//REACT_APP_APPLICATION_SECRET=''



// WEBPACK FOOTER //
// ./src/config.js